import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TextChunk } from '@/utils/ResponseChunker';

export interface InterviewState {
  trustLevel: number;
  conversationId?: string;
  stakeholderId?: string;
  // Cache of chunks by messageId to prevent re-chunking on navigation
  messageChunks: Record<string, TextChunk[]>;
  // Track viewed messages to skip animation on return
  viewedMessageIds: string[];
}

const initialState: InterviewState = {
  trustLevel: 0,
  conversationId: undefined,
  stakeholderId: undefined,
  messageChunks: {},
  viewedMessageIds: []
};

const interviewSlice = createSlice({
  name: 'interview',
  initialState,
  reducers: {
    setTrustLevel: (state, action: PayloadAction<number>) => {
      state.trustLevel = action.payload;
    },
    setConversationId: (state, action: PayloadAction<string>) => {
      state.conversationId = action.payload;
    },
    setStakeholderId: (state, action: PayloadAction<string>) => {
      state.stakeholderId = action.payload;
    },
    cacheMessageChunks: (state, action: PayloadAction<{ messageId: string; chunks: TextChunk[] }>) => {
      state.messageChunks[action.payload.messageId] = action.payload.chunks;
    },
    markMessageViewed: (state, action: PayloadAction<string>) => {
      if (!state.viewedMessageIds.includes(action.payload)) {
        state.viewedMessageIds.push(action.payload);
      }
    },
    clearSessionCache: (state) => {
      state.messageChunks = {};
      state.viewedMessageIds = [];
    },
    resetInterview: () => {
      return initialState;
    }
  }
});

export const {
  setTrustLevel,
  setConversationId,
  setStakeholderId,
  cacheMessageChunks,
  markMessageViewed,
  clearSessionCache,
  resetInterview
} = interviewSlice.actions;

export default interviewSlice.reducer;